import { useMutation } from '@tanstack/react-query';
import { updateAllergy } from '../../../apis/allergy';
import { triggerSnackbar } from '../../../provider/SnackbarProvider';
import queryClient from '../../../lib/queryClient';
import { handleErrorResponse } from '../../../utils/handleError';
import { UpdateAllergyPayload, SubmitAllergyParams } from './types';

export function useAllergy(patientId: number | undefined) {
  const { mutate, isSuccess } = useMutation({
    mutationKey: ['create-allergy'],
    mutationFn: (payload: UpdateAllergyPayload) =>
      updateAllergy(patientId, payload),
    onSuccess: (data) => {
      const message = data?.message;
      if (message) {
        triggerSnackbar({
          message,
          severity: 'success',
        });
      }
      queryClient.invalidateQueries({ queryKey: ['allergy-list'] });
    },
    onError: (error) => handleErrorResponse(error, 'Allergy Creation'),
  });

  const updatePatientAllergy = ({
    id,
    name,
    level,
    durationType,
    durationValue,
    hospitalId,
    _destroy,
  }: SubmitAllergyParams) => {
    const payload: UpdateAllergyPayload = {
      patient: {
        allergies_attributes: [
          {
            id: id || null,
            name,
            level,
            duration_type: durationType,
            duration_value: durationValue,
            hospital_id: hospitalId,
            _destroy,
          },
        ],
      },
    };

    mutate(payload);
  };

  return {
    updatePatientAllergy,
    isSuccess,
  };
}
